module.exports = __webpack_public_path__ + "static/media/S-11.ea8eda78.mp3";